export const EXTRA_INPUT_KEY = 'extraInputs'
